export class ReplaceWithEmailTypeConfig {
  public UsePrimary: boolean = true;
  public EmailAddressTypeIds: number[] = [];
}
